import {ForgotPasswordConfirmParams} from 'domain/usecases';
import {makeForgotPasswordConfirm} from 'main/factories/usecases';

export async function forgotPasswordConfirm({signal, ...params}: ForgotPasswordConfirmParams) {
	const response = await makeForgotPasswordConfirm().forgotPasswordConfirm({
		...params,
		signal,
	});

	return response;
}
